import React, { useEffect, useRef } from 'react';

// Invisible marker placed after a gallery. When it scrolls into view (with a
// generous rootMargin so the next chunk is prefetched before the user reaches
// the bottom), it calls onLoadMore. Shows a spinner while more is loading.
const LoadMoreSentinel = ({ onLoadMore, hasMore, loadingMore }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (!hasMore) return undefined;
        const el = ref.current;
        if (!el) return undefined;

        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) onLoadMore();
            },
            { rootMargin: '600px' } // prefetch ~600px before it enters the viewport
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [hasMore, onLoadMore, loadingMore]);

    if (!hasMore && !loadingMore) return null;

    return (
        <div ref={ref} className="flex justify-center py-10">
            {loadingMore && (
                <div
                    className="h-8 w-8 rounded-full border-2 border-gray-300 border-t-transparent dark:border-gray-600 dark:border-t-transparent animate-spin"
                    role="status"
                    aria-label="Loading more"
                />
            )}
        </div>
    );
};

export default LoadMoreSentinel;
